import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { AppWrapper } from './context';
import reportWebVitals from './reportWebVitals';

const AppComponent = document.getElementById('root');
const root = createRoot(AppComponent);

root.render(
  <React.StrictMode>
    <AppWrapper>
      <App />
    </AppWrapper>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
